.container {
	width: 100%;
	height: 100%;
	border-top: solid 1px var(--border-primary);
	border-left: solid 1px var(--border-primary);
	border-right: solid 1px var(--border-primary);
	border-collapse: separate !important;
	border-radius: 12px 12px 0 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	--header-height: 36px;
}

.container * {
	box-sizing: border-box;
}

.table {
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
}

.header {
	flex-shrink: 0;
	display: table;
	width: 100%;
	table-layout: fixed;
	background-color: var(--elevation-low);
	height: var(--header-height);
}

.header th {
	padding: 8px 12px;
	text-align: left;
	color: var(--content-tertiary);
	border-bottom: 1px solid var(--border-primary);
	vertical-align: middle;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.header th:focus-visible {
	outline: var(--focus-outline);
}

.header th:nth-child(2) {
	padding-left: 8px;
}
